import React from 'react'
import { useSelector } from 'react-redux'
import { userSelector } from '../../store/session'

const ProtectedAccess = ({ allowedRoles, notAllowedRoles, children }) => {
  const { user } = useSelector(userSelector)
  const userRole = user?.role?.type

  const isDenied = notAllowedRoles?.some((role) => role === userRole)
  const isAllowed = !allowedRoles || allowedRoles.some((role) => role === userRole)

  return user && !isDenied && isAllowed ? children : null
}

export default ProtectedAccess
